import { createContext, useContext, useState, ReactNode } from 'react';

export type FilterContextType = {
  timeRange: string;
  setTimeRange: (val: string) => void;
  selectedSector: string;
  setSelectedSector: (val: string) => void;
  selectedOccupation: string;
  setSelectedOccupation: (val: string) => void;
  selectedSkill: string;
  setSelectedSkill: (val: string) => void;
  selectedTab: string;
  setSelectedTab: (val: string) => void;
};

const FilterContext = createContext<FilterContextType | undefined>(undefined);

export const FilterProvider = ({ children }: { children: ReactNode }) => {
  const [timeRange, setTimeRange] = useState("3 Years");
  const [selectedSector, setSelectedSector] = useState('K');
  const [selectedOccupation, setSelectedOccupation] = useState('All');
  const [selectedSkill, setSelectedSkill] = useState('All');
const [selectedTab, setSelectedTab] = useState('PulseCast');
  return (
    <FilterContext.Provider
      value={{
        timeRange,
        setTimeRange,
        selectedSector,
        setSelectedSector,
        selectedOccupation,
        setSelectedOccupation,
        selectedSkill,
        setSelectedSkill,
        selectedTab,
        setSelectedTab,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};

export const useFilter = () => {
  const context = useContext(FilterContext);
  if (!context) throw new Error('useFilter must be used within a FilterProvider');
  return context;
};
export { FilterContext };